import { render, staticRenderFns } from "./DQ.vue?vue&type=template&id=24d0ed96&scoped=true&"
import script from "./DQ.vue?vue&type=script&lang=js&"
export * from "./DQ.vue?vue&type=script&lang=js&"
import style0 from "./DQ.vue?vue&type=style&index=0&id=24d0ed96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0ed96",
  null
  
)

export default component.exports